import Victor from "victor"

export class Point {
    
    /**
     * Creates a new point at the given coordinates.
     * 
     * @param {number} x 
     * @param {number} y 
     *  */ 
    constructor(x, y) { 
        /**
         * @type {number}
         */
        this.x = x; 
        /**
         * 
         * @type {number}
         */
        this.y = y; 
    }

    get vector() {
        return new Victor(this.x, this.y)
    }

    /**
     * @param {Point} point
     * @returns number
     */
    distanceFrom(point) {
        return this.vector.distance(Point.fromObject(point).vector)
    }

    static fromObject(object) {
        return new Point(object.x, object.y);
    }

    toObject() {
        return {
            x: this.x,
            y: this.y
        }
    }

}